module.exports = __webpack_public_path__ + "img/sw_screen-new.df9571fc.jpg";